<template>
    <div class="header bb">
        <!-- 折叠按钮 -->
        <div class="logo flex aic">
            <img src="../../assets/login/logo_project_new.png" alt="">
            <span class="ml10 fs20" v-if="collapse===false">医生工作站</span>
        </div>
        <!--time-->
        <header-time class="fl"></header-time>
        <!--<div class="collapse-btn" @click="collapseChage">
            <i class="el-icon-menu"></i>
        </div>-->
        <!--loading-->
        <transition name="fade">
            <div v-if="showLoading" class="header-loading">
                <img src="../../assets/top-alert-icon-doing.gif" alt="">
                <span class="color_main fs14">&nbsp;数据加载中...</span>
            </div>
        </transition>
        <div class="header-right">
            <ul class="flex aic">
                <li v-for="item in btns" class="flex0 ml20 pointer fs20">
                    <i :class="[item.icon]"></i>
                </li>
                <li class="flex0 ml20 pointer">
                    <el-dropdown @command="handleCommand">
                        <div class="flex user-avator aic">
                            <img :src="docInfo.docAvatar||docDefaultAva" alt="" class="flex radius50 mr10">
                            <span class="flex0 el-dropdown-link color_main">{{docInfo.docName}}<i
                                class="el-icon-arrow-down el-icon--right"></i></span>
                        </div>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="logout">退出</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
  import {loginInfoCache} from "../../lib/cache/LoginInfo";
  import {tokenCache} from "../../lib/cache/Token";
  import {disDepCache,disDocCache,disTypeCache} from "../../lib/cache/DisOrder"
  import HeaderTime from "./header-time";
  import {mapState, mapMutations} from 'vuex';

  const RIGHT_BTNS = [
    /*{name: '消息', icon: 'el-icon-message'},
    {name: '设置', icon: 'el-icon-setting'},
    {name: '联系', icon: 'el-icon-bell'}*/
  ];

  export default {
    components: {HeaderTime},
    data() {
      return {
        collapse: false,
        fullscreen: false,
        showLoading: false,
        btns: RIGHT_BTNS
      }
    },
    created() {
      bus.$on('loading', (data) => {
        this.showLoading = data;
      })
    },
      computed: {
          ...mapState(['userBookDoc']),
      },

    methods: {
      // 用户名下拉菜单选择事件
      handleCommand(command) {
        if (command === 'logout') {
          tokenCache.remove();
          loginInfoCache.remove();
          //清除远程会诊的缓存记录 为了防一台电脑登陆两个账号导致的问题.
            disDepCache.remove();
            disDocCache.remove();
            disTypeCache.remove();
            this.setUserBookDoc([]);
            this.setCurrUserBookDoc({})
          this.$router.push('/login');
        }
      },
      // 侧边栏折叠
      collapseChage() {
        this.collapse = !this.collapse;
        bus.$emit('collapse', this.collapse);
      },
      // 全屏事件
      handleFullScreen() {
        let element = document.documentElement;
        if (this.fullscreen) {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
        } else {
          if (element.requestFullscreen) {
            element.requestFullscreen();
          } else if (element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen();
          } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
          } else if (element.msRequestFullscreen) {
            // IE11
            element.msRequestFullscreen();
          }
        }
        this.fullscreen = !this.fullscreen;
      },
        ...mapMutations(['setCurrUserBookDoc', 'setUserBookDoc'])
    }
  }
</script>
<style scoped lang="scss">
    .header {
        position: relative;
        box-sizing: border-box;
        width: 100%;
        height: 70px;
        color: #fff;
        .header-loading {
            background-color: white;
            position: absolute;
            left: 50%;
            top: 20px;
            height: 30px;
            padding-left: 10px;
            padding-right: 10px;
            display: flex;
            align-items: center;
        }
    }

    .collapse-btn {
        float: left;
        padding: 0 21px;
        cursor: pointer;
        line-height: 70px;
    }

    .header .logo {
        float: left;
        height: 70px;
        width: 190px;
        background-color: #001E42;
        border-right: 1px solid #ffffff;

        img {
            width: 40px;
        }
    }

    .header-right {
        float: right;
        padding-right: 50px;
        color: #666;

        ul {
            height: 70px;
        }
    }

    .header-user-con {
        display: flex;
        height: 70px;
        align-items: center;
    }

    .btn-fullscreen {
        transform: rotate(45deg);
        margin-right: 5px;
        font-size: 24px;
    }

    .btn-bell, .btn-fullscreen {
        position: relative;
        width: 30px;
        height: 30px;
        text-align: center;
        border-radius: 15px;
        cursor: pointer;
    }

    .btn-bell-badge {
        position: absolute;
        right: 0;
        top: -2px;
        width: 8px;
        height: 8px;
        border-radius: 4px;
        background: #f56c6c;
        color: #fff;
    }

    .btn-bell .el-icon-bell {
        color: #fff;
    }

    .user-avator img {
        display: block;
        width: 40px;
        height: 40px;
        border-radius: 50%;
    }

    .el-dropdown-menu__item {
        text-align: center;
    }

    .fade-enter-active, .fade-leave-active {
        transition: all .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
        transform: translateY(-100%);
    }
</style>
